import { render } from "./LoginRoot.vue?vue&type=template&id=c4a31210"
import script from "./LoginRoot.vue?vue&type=script&lang=js"
export * from "./LoginRoot.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__